module.exports = __webpack_public_path__ + "static/media/la-regular-400.5b8ad6f4.svg";